module.exports = __webpack_public_path__ + "media/img/illustrations/icons/navigation-arrow-b8e37d2c74b391d9af4900691d7fefb7.svg";